import Nav from "../Components/Nav";
import Item from "../Components/Sub-Components/Item";



const standardpris = "55,00 DKK";
const højpris = "60,00 DKK";
const Trekant = "17,00 DKK";
const Speciel = "65,00 DKK";

const Sandwich = () => {
  return (
    <div>
    
      <Nav />
      <div className=" relative h-[100vh] gap-5 max-h-screen notranslate">
        <p className="text-white text-center text-3xl Bebas mt-[13vh] border-b">
          Sandwich
        </p>
        <p className="text-white text-center text-md Bebas mt-[5vh]">
          Alle sandwich laves med <br /> salatmayonnaise, salat, tomat & agurk
        </p>
        <p className="text-white text-center text-md Bebas mt-[1vh]">
          Ekstra fyld pr. styk: <span className="text-green-400">10,00 DKK</span>
        </p>
        <p className="text-white text-center text-md Bebas mt-[2vh]">
          Vælg mellem lys/mørk Baguette & Chilibrød, <br />
          samt følgende fyld:
        </p>
        <div className="mt-[2vh]  mb-5 overflow-y-auto w-full small:flex flex-wrap justify-center items-center">
          <Item
            img="/Assets/item1.jfif"
            // new="/Assets/news.png"
            name="Kylling & soltørrede tomater"
            desc="m. Grøn pesto"
            price={højpris}
          />
        <Item
            img="/Assets/chickendorito.jpg"
            // new="/Assets/news.png"
            name="Kylling Doritos"
            desc="m. Stærk Salsa"
            price={højpris}
          />
            <Item
              img="/Assets/crispychicken.jpg"
              name="Crispy Chicken m. Chili/Mango dressing"
              desc="(Bestilles)"
              price={Speciel}
            />
          <Item
            img="/Assets/kyllingsand.jpg"
            name="Kylling/Bacon"
            desc="m. Hjemmelavet karrydressing"
            price={højpris}
          />
          <Item
            img="/Assets/2-2.jpg"
            name="Flæskesteg m. Rødkål & agurkesalat"
            desc="+ Sennep hvis det ønskes"
            price={højpris}
          />
          <Item
            img="/Assets/frikasand.jpg"
            name="Frikadelle m. Rødkål & agurkesalat"
            price={højpris}
          />
          <Item
            img="/Assets/2-3.jpg"
            name="Skinke/ost"
            desc="Med eller uden Dijonsennep"
            price={standardpris}
          />
          <Item
            img="/Assets/homemadepork.jfif"
            name="Skinke m. Hjemmelavet røræg"
            price={standardpris}
          />
          <Item
            img="/Assets/sandæg.jpg"
            name="Æg & Rejer"
            price={Speciel}
          />
          <Item
            img="/Assets/1-7.jpg"
            name="Æg & Tomat"
            price={højpris}
          />
          <Item
            img="/Assets/ægbacon.jfif"
            name="Æg & Bacon"
            price={højpris}
          />
          <Item
            img="/Assets/kebab.jpg"
            name="Kebab m. Chilimayonnaise"
            desc="& syltede løg"
            price={Speciel}
          />
          <Item
            img="/Assets/1-10.jpg"
            name="Rullepølse m. Rå løg"
            price={standardpris}
          />
         
          <Item
            img="/Assets/tunsalat.jpg"
            name="Tunsalat m. Rå løg"
            price={standardpris}
          />
          <Item
            img="/Assets/sandkart.jpg"
            name="Kartoffel m. Tomat, mayonnaise,"
            desc="ristet & rå løg"
            price={højpris}
          />
          <Item
            img="/Assets/2-5.jpg"
            name="Roastbeef m. Remoulade, ristet løg,"
            desc="peberrod & drueagurk"
            price={Speciel}
          />
          <Item
            img="/Assets/2-4.jpg"
            name="Laks m. Hjemmelavet røræg"
            price={Speciel}
          />
          <Item
            img="/Assets/pulledpork.jfif"
            name="Pulled Pork m."
            desc="hjemmelavet coleslaw"
            price={Speciel}
          />
          <Item
            img="/Assets/serrano.jfif"
            name="Serrano-/Parmaskinke"
            desc="m. Pesto & brieost"
            price={Speciel}
          />
          <Item
            img="/Assets/2-18.jpg"
            name="Trekant sandwich"
            price={Trekant}
          />
        </div>
      </div>
    </div>
  );
};

export default Sandwich;
